import { gql } from '@apollo/client'

import { MENU_MODIFIER_FRAGMENT } from '../menu/modifier'

export const SHOP_CART_ITEM_MODIFIER_FRAGMENT = gql`
  fragment ShopCartItemModifier on ShopCartItemModifier {
    id
    modifier {
      ...MenuModifier
    }
    quantity
    totalPrice
    totalPriceFormatted
  }
  ${MENU_MODIFIER_FRAGMENT}
`
